import React from 'react';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
};

export function Label({ children, required, style, ...rest }: LabelProps) {
  return (
    <label
      {...rest}
      style={{
        display: 'inline-flex',
        gap: '0.25rem',
        fontWeight: 'var(--font-weight-bold)',
        fontSize: 'var(--font-size-base)',
        lineHeight: '1.5rem',
        color: 'var(--color-text-primary, #111827)',
        marginBottom: 0,
        ...style
      }}
    >
      <span>{children}</span>
      {required && (
        <span aria-hidden="true" style={{ color: 'var(--ds-accent, #ef4444)' }}>
          *
        </span>
      )}
    </label>
  );
}
